var _path, _path2, _g, _path3, _path4, _g2, _g3, _path5, _g4, _g5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNetworking = function SvgNetworking(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 217,
    viewBox: "0 0 214 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.183 174.098H184.416C183.897 174.098 183.47 173.365 183.47 172.458V144.761C183.47 143.854 183.897 143.121 184.416 143.121H205.183C205.956 143.121 206.409 144.627 205.956 145.707L200.998 157.663C200.758 158.236 200.758 158.996 200.998 159.556L205.956 171.512C206.409 172.591 205.956 174.098 205.183 174.098Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95354 143.121H29.7201C30.2399 143.121 30.6665 143.854 30.6665 144.761V172.458C30.6665 173.365 30.2399 174.098 29.7201 174.098H8.95354C8.18046 174.098 7.72725 172.591 8.18044 171.512L13.1388 159.556C13.3787 158.983 13.3787 158.223 13.1388 157.663L8.18044 145.707C7.72725 144.627 8.18046 143.121 8.95354 143.121Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9217 57.1758C24.9217 52.524 27.2143 48.1521 31.0931 45.5796C51.2332 32.1573 77.8644 24 107.082 24C136.299 24 162.93 32.1707 183.07 45.5796C186.936 48.1655 189.241 52.524 189.241 57.1758V159.249C189.241 163.901 186.949 168.273 183.083 170.845C162.943 184.268 136.312 192.425 107.095 192.425C77.8778 192.425 51.2464 184.254 31.1063 170.845C27.2409 168.26 24.935 163.901 24.935 159.249V57.1758H24.9217Z",
    fill: "url(#paint0_linear_1241_129817)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6668 60.1216C29.6668 55.7364 31.8261 51.6177 35.4782 49.1918C54.4454 36.5426 79.5439 28.8518 107.068 28.8518C134.593 28.8518 159.691 36.5426 178.658 49.1918C182.31 51.6177 184.47 55.7364 184.47 60.1216V156.29C184.47 160.675 182.31 164.794 178.658 167.22C159.691 179.869 134.593 187.56 107.068 187.56C79.5439 187.56 54.4454 179.869 35.4782 167.22C31.8261 164.794 29.6668 160.675 29.6668 156.29V60.1216Z",
    fill: "url(#paint1_linear_1241_129817)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_129817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 28,
    width: 156,
    height: 160
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6668 60.1881C29.6668 55.8029 31.8261 51.6842 35.4782 49.2584C54.4454 36.6092 79.5439 28.9183 107.068 28.9183C134.593 28.9183 159.691 36.6092 178.658 49.2584C182.31 51.6842 184.47 55.8029 184.47 60.1881V156.357C184.47 160.742 182.31 164.861 178.658 167.287C159.691 179.936 134.593 187.627 107.068 187.627C79.5439 187.627 54.4454 179.936 35.4782 167.287C31.8261 164.861 29.6668 160.742 29.6668 156.357V60.1881Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.308 242.049C181.28 242.049 239.625 215.117 239.625 181.895C239.625 148.673 181.28 121.741 109.308 121.741C37.3352 121.741 -21.01 148.673 -21.01 181.895C-21.01 215.117 37.3352 242.049 109.308 242.049Z",
    fill: "#5C4AE5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.655 45.593C149.266 45.593 149.761 45.0977 149.761 44.4867C149.761 43.8757 149.266 43.3804 148.655 43.3804C148.044 43.3804 147.548 43.8757 147.548 44.4867C147.548 45.0977 148.044 45.593 148.655 45.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.094 54.2834C151.441 54.2834 152.533 53.1914 152.533 51.8442C152.533 50.4971 151.441 49.405 150.094 49.405C148.747 49.405 147.655 50.4971 147.655 51.8442C147.655 53.1914 148.747 54.2834 150.094 54.2834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.785 50.2848C158.081 50.2848 159.131 49.2345 159.131 47.9389C159.131 46.6433 158.081 45.593 156.785 45.593C155.49 45.593 154.439 46.6433 154.439 47.9389C154.439 49.2345 155.49 50.2848 156.785 50.2848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.527 139.802C50.3809 139.802 51.0732 139.11 51.0732 138.256C51.0732 137.402 50.3809 136.71 49.527 136.71C48.673 136.71 47.9808 137.402 47.9808 138.256C47.9808 139.11 48.673 139.802 49.527 139.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1691 134.271C44.5162 134.271 45.6082 133.179 45.6082 131.832C45.6082 130.484 44.5162 129.392 43.1691 129.392C41.822 129.392 40.7299 130.484 40.7299 131.832C40.7299 133.179 41.822 134.271 43.1691 134.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8362 140.895C42.4472 140.895 42.9424 140.4 42.9424 139.789C42.9424 139.178 42.4472 138.683 41.8362 138.683C41.2252 138.683 40.7299 139.178 40.7299 139.789C40.7299 140.4 41.2252 140.895 41.8362 140.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.659 139.176L174.659 142.455C174.353 142.961 173.607 142.961 173.287 142.455L171.287 139.176C171.127 138.923 171.127 138.603 171.287 138.336L173.287 135.057C173.593 134.551 174.34 134.551 174.659 135.057L176.659 138.336C176.819 138.589 176.819 138.923 176.659 139.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.422 136.55L167.209 138.536C167.022 138.843 166.569 138.843 166.382 138.536L165.169 136.55C165.076 136.39 165.076 136.203 165.169 136.043L166.382 134.057C166.569 133.751 167.022 133.751 167.209 134.057L168.422 136.043C168.515 136.203 168.515 136.39 168.422 136.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9389 60.4015L52.7659 62.3075C52.5793 62.6008 52.1528 62.6008 51.9662 62.3075L50.8066 60.4015C50.7133 60.2549 50.7133 60.0683 50.8066 59.9083L51.9662 58.0023C52.1528 57.709 52.5793 57.709 52.7659 58.0023L53.9389 59.9083C54.0322 60.0549 54.0322 60.2415 53.9389 60.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3938 69.5051L47.1278 73.2106C46.7679 73.7837 45.9282 73.7837 45.5817 73.2106L43.3157 69.5051C43.1425 69.2119 43.1425 68.852 43.3157 68.5588L45.5817 64.8533C45.9416 64.2802 46.7813 64.2802 47.1278 64.8533L49.3938 68.5588C49.567 68.852 49.567 69.2119 49.3938 69.5051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82 128.966L171.247 131.538C171.007 131.938 170.421 131.938 170.168 131.538L168.595 128.966C168.475 128.766 168.475 128.513 168.595 128.313L170.168 125.74C170.408 125.34 170.994 125.34 171.247 125.74L172.82 128.313C172.94 128.513 172.94 128.766 172.82 128.966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_129817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 166,
    height: 169
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9217 57.1758C24.9217 52.524 27.2143 48.1521 31.0931 45.5796C51.2332 32.1573 77.8644 24 107.082 24C136.299 24 162.93 32.1707 183.07 45.5796C186.936 48.1655 189.241 52.524 189.241 57.1758V159.249C189.241 163.901 186.949 168.273 183.083 170.845C162.943 184.268 136.312 192.425 107.095 192.425C77.8778 192.425 51.2464 184.254 31.1063 170.845C27.2409 168.26 24.935 163.901 24.935 159.249V57.1758H24.9217Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.2159 246.501C19.6167 239.25 18.3105 235.158 15.7114 226.014C33.1324 213.085 51.8462 204.341 70.3735 193.332C89.9671 181.695 105.869 166.487 123.17 151.785C158.985 121.382 185.349 116.023 230.641 128.193C233.24 130.525 234.547 131.725 237.146 134.324C190.974 120.689 164.929 131.512 129.674 162.502C95.352 192.692 54.5387 214.631 22.2026 246.488L22.2159 246.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M12.2059 230.346C-3.62898 202.275 -10.6667 169.193 -18.051 138.229C29.3203 138.989 54.6186 115.237 89.4206 86.2064C124.942 56.5761 152.627 48.7253 196.892 63.4139C207.369 73.8238 217.419 84.0605 227.149 95.1768C181.111 73.3173 151.107 103.241 119.677 135.377C85.6752 170.152 47.5677 197.49 12.2059 230.346Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M110.081 145.307C133.711 145.307 152.867 126.151 152.867 102.521C152.867 78.891 133.711 59.735 110.081 59.735C86.4505 59.735 67.2946 78.891 67.2946 102.521C67.2946 126.151 86.4505 145.307 110.081 145.307Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.081 60.5082C133.246 60.5082 152.094 79.3554 152.094 102.521C152.094 125.687 133.246 144.534 110.081 144.534C86.9148 144.534 68.0676 125.687 68.0676 102.521C68.0676 79.3554 86.9148 60.5082 110.081 60.5082ZM110.081 58.9753C86.0217 58.9753 66.5214 78.4757 66.5214 102.534C66.5214 126.593 86.0217 146.094 110.081 146.094C134.139 146.094 153.64 126.593 153.64 102.534C153.64 78.4757 134.139 58.9753 110.081 58.9753Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.081 137.483C90.8068 137.483 75.1187 121.795 75.1187 102.521C75.1187 83.2474 90.8068 67.5592 110.081 67.5592C129.354 67.5592 145.043 83.2474 145.043 102.521C145.043 121.795 129.354 137.483 110.081 137.483Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.081 68.3323C128.928 68.3323 144.269 83.6739 144.269 102.521C144.269 121.368 128.928 136.71 110.081 136.71C91.2333 136.71 75.8917 121.368 75.8917 102.521C75.8917 83.6739 91.2333 68.3323 110.081 68.3323ZM110.081 66.7994C90.3536 66.7994 74.3455 82.7942 74.3455 102.534C74.3455 122.275 90.3403 138.269 110.081 138.269C129.821 138.269 145.816 122.275 145.816 102.534C145.816 82.7942 129.821 66.7994 110.081 66.7994Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.315 56.7627C127.968 54.9233 123.276 34.4766 104.216 62.9473C83.5426 93.8306 79.7838 135.604 81.3433 141.588C82.9028 147.573 85.5019 153.558 94.0991 148.879",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.083 52.5374C102.083 52.5374 92.1931 41.6743 86.9948 54.1635C81.7965 66.6528 84.3956 108.466 96.7116 132.578C109.028 156.69 116.838 157.556 121.517 148.533",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7504 95.9232C59.7504 95.9232 50.2468 84.7402 70.5468 82.0077C90.8469 79.2753 146.509 97.6693 157.972 114.53C166.822 127.54 150.947 127.806 150.947 127.806",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8836 108.026C59.8836 108.026 53.1125 99.3088 66.3882 96.7096C79.6639 94.1105 131.567 103.347 148.481 126.9C148.481 126.9 152.52 135.884 141.977 136.923",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.241 71.198C149.241 71.198 161.064 72.5709 155.119 82.6476C147.442 95.6567 108.015 126.62 67.9476 127.793C67.9476 127.793 53.5124 127.406 61.8297 113.478",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.977 68.0923C100.977 68.0923 86.9415 103.467 133.38 129.619",
    stroke: "#61D4ED",
    strokeWidth: 1.53283,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.35 56.0562C103.513 56.0562 104.456 55.1133 104.456 53.9502C104.456 52.7871 103.513 51.8442 102.35 51.8442C101.187 51.8442 100.244 52.7871 100.244 53.9502C100.244 55.1133 101.187 56.0562 102.35 56.0562Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.857 55.9896C102.99 56.2562 104.123 55.5631 104.389 54.4301C104.656 53.2971 103.963 52.1642 102.83 51.8976L101.857 55.9896Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.315 59.7617C129.559 59.7617 130.567 58.7531 130.567 57.5091C130.567 56.265 129.559 55.2565 128.315 55.2565C127.071 55.2565 126.062 56.265 126.062 57.5091C126.062 58.7531 127.071 59.7617 128.315 59.7617Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.795 59.695C129.008 59.9883 130.221 59.2418 130.501 58.0289C130.78 56.816 130.047 55.603 128.834 55.3231L127.795 59.695Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.241 73.4373C150.478 73.4373 151.48 72.4347 151.48 71.198C151.48 69.9613 150.478 68.9587 149.241 68.9587C148.004 68.9587 147.002 69.9613 147.002 71.198C147.002 72.4347 148.004 73.4373 149.241 73.4373Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.721 73.3839C149.921 73.6772 151.134 72.9308 151.414 71.7312C151.694 70.5315 150.961 69.3186 149.761 69.0387L148.721 73.3839Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.961 129.606C151.962 129.606 152.773 128.794 152.773 127.793C152.773 126.792 151.962 125.98 150.961 125.98C149.959 125.98 149.148 126.792 149.148 127.793C149.148 128.794 149.959 129.606 150.961 129.606Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.534 129.566C151.507 129.792 152.493 129.192 152.72 128.219C152.947 127.246 152.347 126.26 151.374 126.033L150.534 129.566Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.137 138.763C142.16 138.763 142.99 137.933 142.99 136.91C142.99 135.887 142.16 135.057 141.137 135.057C140.114 135.057 139.284 135.887 139.284 136.91C139.284 137.933 140.114 138.763 141.137 138.763Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.697 138.709C141.697 138.949 142.697 138.336 142.937 137.336C143.176 136.337 142.563 135.337 141.564 135.097L140.697 138.709Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.504 149.759C122.726 149.759 123.716 148.768 123.716 147.546C123.716 146.324 122.726 145.334 121.504 145.334C120.282 145.334 119.291 146.324 119.291 147.546C119.291 148.768 120.282 149.759 121.504 149.759Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.997 149.706C122.183 149.986 123.383 149.252 123.663 148.066C123.943 146.88 123.21 145.68 122.023 145.4L120.997 149.706Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8189 149.919C95.9673 149.919 96.8983 148.988 96.8983 147.84C96.8983 146.691 95.9673 145.76 94.8189 145.76C93.6706 145.76 92.7396 146.691 92.7396 147.84C92.7396 148.988 93.6706 149.919 94.8189 149.919Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3391 149.852C95.4587 150.119 96.5784 149.426 96.8316 148.32C97.0849 147.213 96.4051 146.08 95.2988 145.827L94.3391 149.866V149.852Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9097 115.69C63.139 115.69 64.1356 114.694 64.1356 113.464C64.1356 112.235 63.139 111.238 61.9097 111.238C60.6803 111.238 59.6837 112.235 59.6837 113.464C59.6837 114.694 60.6803 115.69 61.9097 115.69Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4031 115.624C62.6027 115.903 63.8024 115.17 64.0823 113.971C64.3622 112.771 63.629 111.572 62.4294 111.292L61.4031 115.624Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2435 109.479C61.3478 109.479 62.2429 108.584 62.2429 107.479C62.2429 106.375 61.3478 105.48 60.2435 105.48C59.1393 105.48 58.2442 106.375 58.2442 107.479C58.2442 108.584 59.1393 109.479 60.2435 109.479Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.777 109.426C60.8566 109.679 61.9363 109.012 62.1895 107.946C62.4428 106.88 61.7763 105.787 60.71 105.533L59.777 109.439V109.426Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2435 97.9759C61.2594 97.9759 62.0829 97.1524 62.0829 96.1365C62.0829 95.1206 61.2594 94.2971 60.2435 94.2971C59.2276 94.2971 58.4041 95.1206 58.4041 96.1365C58.4041 97.1524 59.2276 97.9759 60.2435 97.9759Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.817 97.9359C60.8034 98.1759 61.7897 97.5627 62.0296 96.5764C62.2695 95.59 61.6564 94.6037 60.6701 94.3638L59.817 97.9359Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.124 70.3183C101.368 70.3183 102.376 69.3098 102.376 68.0657C102.376 66.8216 101.368 65.8131 100.124 65.8131C98.8797 65.8131 97.8712 66.8216 97.8712 68.0657C97.8712 69.3098 98.8797 70.3183 100.124 70.3183Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.604 70.2517C100.817 70.5449 102.03 69.7985 102.31 68.5855C102.59 67.3726 101.857 66.1597 100.644 65.8798L99.604 70.2517Z",
    fill: "#37CAD1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1241_129817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.527 131.845C133.771 131.845 134.779 130.836 134.779 129.592C134.779 128.348 133.771 127.34 132.527 127.34C131.283 127.34 130.274 128.348 130.274 129.592C130.274 130.836 131.283 131.845 132.527 131.845Z",
    fill: "#61D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.007 131.778C133.22 132.071 134.433 131.325 134.713 130.112C134.993 128.899 134.259 127.686 133.046 127.406L132.007 131.778Z",
    fill: "#37CAD1"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.699 184.321C128.741 166.847 82.9161 166.98 34.0787 184.721C32.1327 185.534 30 184.948 29.3203 183.375C25.2682 174.138 23.2422 169.526 19.1902 160.289C18.4971 158.716 19.7634 156.637 22.0426 155.69C78.4376 134.737 133.073 134.577 189.601 155.224C191.881 156.157 193.16 158.223 192.48 159.796C188.482 169.046 186.482 173.671 182.47 182.935C181.791 184.508 179.671 185.107 177.712 184.308L177.699 184.321Z",
    fill: "#4539FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0683 163.914L63.8424 164.368L58.9506 159.476L60.1102 165.127L57.8843 165.58L56.0049 156.41L58.2442 155.957L63.1359 160.875L61.9763 155.197L64.2156 154.744L66.0949 163.914H66.0683Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6005 155.704L69.9071 157.57L72.9194 157.09L73.1993 158.823L70.1869 159.303L70.5202 161.329L73.9324 160.782L74.2257 162.581L68.5608 163.488L67.068 154.251L72.7328 153.344L73.026 155.144L69.6138 155.69L69.6005 155.704Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0631 152.132L82.2897 153.944L79.8238 154.251L80.7435 161.728L78.4776 162.008L77.5579 154.531L75.092 154.837L74.8654 153.025L82.0498 152.145L82.0631 152.132Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3514 150.932L95.5787 160.435L92.8329 160.635L90.9136 154.597L89.8072 160.849L87.0615 161.049L84.0358 151.878L86.475 151.705L88.3011 158.409L89.4874 151.505L91.9932 151.332L94.0725 158.01L94.9522 151.118L97.4048 150.945L97.3514 150.932Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.977 159.702C101.244 159.303 100.644 158.743 100.217 158.01C99.7773 157.277 99.5507 156.463 99.5374 155.544C99.5241 154.624 99.7374 153.798 100.151 153.065C100.577 152.331 101.15 151.758 101.87 151.332C102.603 150.919 103.403 150.705 104.283 150.692C105.162 150.692 105.975 150.879 106.708 151.278C107.441 151.678 108.028 152.238 108.468 152.958C108.894 153.678 109.121 154.504 109.134 155.41C109.148 156.317 108.948 157.157 108.521 157.89C108.095 158.623 107.535 159.209 106.802 159.622C106.082 160.036 105.282 160.249 104.403 160.262C103.523 160.276 102.71 160.076 101.977 159.676V159.702ZM106.162 157.436C106.602 156.93 106.828 156.277 106.815 155.45C106.815 154.624 106.575 153.971 106.122 153.478C105.669 152.985 105.069 152.745 104.323 152.758C103.563 152.758 102.963 153.025 102.523 153.518C102.083 154.011 101.857 154.677 101.87 155.517C101.87 156.344 102.11 156.997 102.563 157.49C103.016 157.983 103.616 158.223 104.376 158.21C105.122 158.21 105.722 157.943 106.162 157.436Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.065 160.369L114.253 156.77H113.706L113.573 160.276L111.294 160.196L111.627 150.839L115.452 150.972C116.185 150.999 116.812 151.145 117.318 151.425C117.825 151.705 118.198 152.065 118.451 152.531C118.691 152.985 118.798 153.491 118.784 154.038C118.758 154.664 118.571 155.211 118.198 155.677C117.825 156.157 117.305 156.477 116.612 156.663L118.638 160.449L116.065 160.356V160.369ZM113.759 155.144L115.172 155.197C115.585 155.211 115.905 155.117 116.119 154.931C116.332 154.744 116.452 154.451 116.465 154.078C116.465 153.718 116.385 153.438 116.185 153.225C115.985 153.011 115.679 152.905 115.252 152.891L113.839 152.838L113.759 155.157V155.144Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.235 161.035L123.436 156.663L123.103 160.782L120.837 160.595L121.597 151.265L123.863 151.452L123.53 155.544L126.968 151.705L129.634 151.918L125.649 156.197L129.008 161.262L126.235 161.035Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.299 152.478L133.22 161.768L130.954 161.502L132.033 152.212L134.299 152.478Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.03 163.341L141.777 162.995L138.885 156.703L138.005 162.408L135.752 162.062L137.178 152.811L139.431 153.158L142.31 159.476L143.19 153.744L145.442 154.091L144.016 163.341H144.03Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.853 158.769C153.746 158.436 153.56 158.143 153.293 157.93C153.013 157.703 152.667 157.543 152.253 157.463C151.534 157.316 150.907 157.436 150.374 157.81C149.841 158.196 149.494 158.783 149.321 159.569C149.148 160.409 149.241 161.115 149.601 161.688C149.961 162.262 150.534 162.621 151.334 162.795C151.88 162.901 152.373 162.861 152.813 162.661C153.253 162.461 153.613 162.115 153.893 161.635L151.067 161.049L151.414 159.409L156.265 160.422L155.839 162.501C155.559 163.021 155.172 163.488 154.679 163.874C154.186 164.274 153.6 164.554 152.933 164.727C152.267 164.901 151.547 164.901 150.774 164.741C149.868 164.554 149.108 164.181 148.481 163.648C147.855 163.101 147.415 162.435 147.162 161.648C146.909 160.862 146.882 160.022 147.068 159.116C147.255 158.21 147.628 157.45 148.161 156.823C148.708 156.197 149.374 155.757 150.161 155.504C150.947 155.25 151.8 155.224 152.693 155.41C153.786 155.637 154.653 156.09 155.306 156.783C155.946 157.476 156.292 158.303 156.345 159.302L153.88 158.796L153.853 158.769Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_129817",
    x: 0.929514,
    y: 0.00782204,
    width: 212.304,
    height: 216.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9961
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_129817",
    x: 56.7618,
    y: 47.1736,
    width: 105.14,
    height: 107.884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.479844,
    dy: 0.479844
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1241_129817",
    x: 100.244,
    y: 51.8442,
    width: 4.33187,
    height: 4.33187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.119961,
    dy: 0.119961
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1241_129817",
    x: 126.062,
    y: 55.2565,
    width: 4.63848,
    height: 4.63854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1241_129817",
    x: 147.002,
    y: 68.9587,
    width: 4.61187,
    height: 4.6223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1241_129817",
    x: 149.148,
    y: 125.98,
    width: 3.73206,
    height: 3.74005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.106632,
    dy: 0.106632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1241_129817",
    x: 139.284,
    y: 135.057,
    width: 3.81208,
    height: 3.81208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.106632,
    dy: 0.106632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1241_129817",
    x: 119.291,
    y: 145.334,
    width: 4.56475,
    height: 4.56481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1241_129817",
    x: 92.7396,
    y: 145.76,
    width: 4.27859,
    height: 4.27865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.119961,
    dy: 0.119961
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1241_129817",
    x: 59.6837,
    y: 111.238,
    width: 4.59142,
    height: 4.58519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1241_129817",
    x: 58.2442,
    y: 105.48,
    width: 4.11905,
    height: 4.11911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.119961,
    dy: 0.119961
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1241_129817",
    x: 58.4041,
    y: 94.2971,
    width: 3.78546,
    height: 3.79743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.106632,
    dy: 0.106632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1241_129817",
    x: 97.8712,
    y: 65.8131,
    width: 4.63848,
    height: 4.63854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1241_129817",
    x: 130.274,
    y: 127.34,
    width: 4.63848,
    height: 4.63854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.13329,
    dy: 0.13329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_129817",
    x1: 107.068,
    y1: 242.422,
    x2: 107.068,
    y2: 72.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1ABDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3F9BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5B80FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6F6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7B62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_129817",
    x1: 107.068,
    y1: -9.1358,
    x2: 107.068,
    y2: 151.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1ABDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3F9BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5B80FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6F6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7B62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNetworking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "networking.dcb13a8.svg";